<template>
<div class="chapter">
<div class="inner_page">
<p class="FM-Head">Author’s Note</p>
<p class="Noindent">The terms Viet Cong (VC) and North Vietnamese Army (NVA) are used throughout this text rather than the more proper National Liberation Front (NLF) and People’s Army of Vietnam (PAVN). This choice was made because of the general readership’s greater familiarity with the former terms than the latter ones and they are terms that have always been used by me and others.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Fm03.vue?70a0a9f5